import { Services, isEmpty } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import render from './render'

export default {
  name: 'ExpireFields',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  computed: {
    items() {
      const result = []
      const { expireAfterHrs, deleteAfterExpireDays, expireUrl } = this.value || {}
      if (!isEmpty(expireAfterHrs)) {
        result.push({
          tooltip: this.getTranslate(`${Services['url-shortener']}.tooltips.expireAfterHrs`, { expireAfterHrs }),
          icon: icons.schedule
        })
      }
      if (!isEmpty(deleteAfterExpireDays)) {
        result.push({
          tooltip: this.getTranslate(`${Services['url-shortener']}.tooltips.deleteAfterExpireDays`, { deleteAfterExpireDays }),
          icon: icons.auto_delete
        })
      }
      if (!isEmpty(expireAfterHrs)) {
        let expireBehaviorTooltip = this.getTranslate(`${Services['url-shortener']}.tooltips.expire404`)
        if (!isEmpty(expireUrl)) {
          expireBehaviorTooltip = this.getTranslate(`${Services['url-shortener']}.tooltips.expireUrl`, { expireUrl })
        }
        result.push({
          tooltip: expireBehaviorTooltip,
          icon: icons.link_off
        })
      }

      return result
    }
  },

  render
}
